import React from "react";

import { Typography, Space } from "antd";
import { GRAY5, GRAY_PLACEHOLDER } from "../../constant/colors";
import FloatLabel from "./FloatLabel";
import { DatePicker } from "@tailormed/common-client/component/DatePicker";

const { Text } = Typography;

const CustomDatePicker = ({ children, style = {}, required = false, ...props }) => {
  // there's a current bug in DatePicker by antd - if DatePicker has value and defaultPickerValue -
  // when clicked on it will show the defaultPickerValue date panel instead of the value
  // this condition is here to prevent that
  if (props.value && props.defaultPickerValue) {
    delete props.defaultPickerValue;
  }
  return (
    <FloatLabel
      label={
        <Space size={4}>
          {required && <Text style={{ color: GRAY_PLACEHOLDER }}>*</Text>}
          <Text style={{ color: GRAY_PLACEHOLDER }}>{props.label}</Text>
        </Space>
      }
      name={props.label}
      value={props.value}
    >
      <DatePicker
        {...props}
        placeholder={props.placeholder}
        style={{
          width: "100%",
          border: "0px",
          borderRadius: "0",
          borderBottom: `1px solid ${GRAY5}`,
          padding: props.label ? "14px 0 0 11px" : "",
          ...style
        }}
      >
        {children}
      </DatePicker>
    </FloatLabel>
  );
};

export { CustomDatePicker };
